import { useEffect, useState } from "react";
import moment from "moment";
import { toast } from "react-toastify";

import { getReportRangeErrorMessage } from "src/utils/report/reportRange.util";

import { dailyReportColumnHeaders } from "../../pages/report/constants";
import { AnalyticsService } from "../../services";
import { downloadFile } from "../../utils/download.utils";
import { MTable } from "../v3";

const TYPE_MAPPING = {
  WORKER_PAYMENT: "Worker Payment",
  CLIENT: "Client Income",
  SUBCONTRACTOR: "Subcontractor Payment",
  EMPLOYEE: "Employee Payment",
  CASH: "Account Transaction",
  USER: "Account Transaction",
  BANK: "Account Transaction",
  EXPENSE_PAYMENT: "Expense Payment",
  CLIENT_RECEIPT: "Client Income",
  ACCOUNT_TRANSACTION: "Account Transaction",
  VENDOR_PAYMENT: "Vendor Payment",
  SUBCONTRACTOR_PAYMENT: "Subcontractor Payment",
};

export const DailyReportResults = ({
  data = {},
  loading = false,
  paginationState = { page: 0, pageSize: 10 },
  handlePaginationChange = () => {},
  reportFilters = {},
}) => {
  const [isPdfGenerating, setIsPdfGenerating] = useState(false);
  const [pdfSuccess, setPdfSuccess] = useState(false);
  const [prevFilters, setPrevFilters] = useState({});

  useEffect(() => {
    if (pdfSuccess && JSON.stringify(reportFilters) !== JSON.stringify(prevFilters)) {
      setPdfSuccess(false);
    }
  }, [reportFilters, prevFilters, pdfSuccess]);

  const handleDownloadPdfClick = async () => {
    setIsPdfGenerating(true);
    setPdfSuccess(false);

    try {
      const response = await AnalyticsService.downloadDailyReportPdf(reportFilters || {});
      const currentDateTime = moment().format("YYYYMMDD-HHmmss");
      const filename = `daily-report-${currentDateTime}.pdf`;

      downloadFile(response.data, filename);
      toast.success("Report downloaded successfully");

      setPdfSuccess(true);
      setPrevFilters(reportFilters);
    } catch (error) {
      console.error("Report download failed:", error);
      toast.error((await getReportRangeErrorMessage(error)) ?? "Failed to download report");
    } finally {
      setIsPdfGenerating(false);
    }
  };

  const rows =
    data?.rows?.map((row, index) => {
      return {
        id: row.entryId,
        sl: index + 1 + (paginationState?.page ?? 0) * (paginationState?.pageSize ?? 0),
        projectName: row.projectName,
        entryBy: row.createdByName,
        description: row?.description || "",
        particulars:
          row.entryType === "expense"
            ? row.categoryName
            : row.entryType === "receivable"
              ? "Client Receivable"
              : TYPE_MAPPING[row?.type],
        amount: ["expense", "receivable", "contract"].includes(row.entryType) && row?.type !== "transaction" ? row.amount : "",
        cashIn: row?.meta?.isRelatedToIncome ? row.amount : "",
        cashOut: row?.entryType === "transaction" && !row?.meta?.isRelatedToIncome ? row.amount : "",
      };
    }) || [];

  return (
    <MTable
      showExportButton
      isPdfGenerating={isPdfGenerating}
      pdfSuccess={pdfSuccess}
      currentFilters={reportFilters}
      prevFilters={prevFilters}
      onExportPdfClick={handleDownloadPdfClick}
      columnHeaders={dailyReportColumnHeaders}
      tableRows={rows}
      rowCount={data?.count}
      loading={loading}
      paginationModel={paginationState}
      onPaginationChange={handlePaginationChange}
    />
  );
};
